import { render, staticRenderFns } from "./AllocatedBudgetReport.vue?vue&type=template&id=aeece4da&scoped=true"
import script from "./AllocatedBudgetReport.vue?vue&type=script&lang=js"
export * from "./AllocatedBudgetReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeece4da",
  null
  
)

export default component.exports